// extracted by mini-css-extract-plugin
export default {"button":"aMU9d","link":"_30E79","container":"_1R-Er","mobile-container":"_32jDD","mobileContainer":"_32jDD"};